/* eslint-disable no-unused-vars */
function initSmallLayoutAnimations() {
  // Standard to top link animation
  $('.top-link').on('click', () => {
    $('body,html').animate({
      scrollTop: 0,
    }, 800);
  });
}
